
import { Box, Grid, Typography, useMediaQuery, Container, useTheme, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const ThankYou = () => {
    const theme = useTheme();

    const matches = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <>
            <Box>
                <Container >
                    <Grid
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems='center'
                        justifyContent='center'
                        textAlign='center'
                    >
                        <Box
                            sx={{ padding: matches ? theme.spacing(2) : theme.spacing(10) }}
                        >
                            <Typography variant='h1' sx={{ color: theme.palette.primary.main }}>
                                Thank You
                            </Typography>
                            <Typography mt={theme.spacing(3)}>
                                Thank you for contacting us. We will get back to you soon.
                            </Typography>

                            <Button
                                component={Link}
                                to="/"
                                variant="contained"
                                size="large"
                                sx={{
                                    marginTop: theme.spacing(2),
                                    minWidth: 200
                                }}
                            >
                                Back to Home
                            </Button>
                        </Box>
                    </Grid>
                </Container>

            </Box>
        </>
    );
};
